<div class="field purpose">
  <ng-container *ngFor="let purpose of purposes">
    <div class="btn btn-purpose" [ngStyle]="cssStyles(purpose)" (click)="setPurpose(purpose)">
      <span>{{ purpose.title }}</span>
      <app-icon [height]="30" [width]="30" [icon]="isActivePurpose(purpose) ? 'check-checked' : 'check-unchecked'"></app-icon>
    </div>
  </ng-container>
</div>
